import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { Configuration } from '../constants/configuration';
import { StorageService } from './storage.service';
import { QuattroB2C } from '../models/quattroB2C.model';
import { CopsisResponse } from '../models/copsis-response.model';
import { B2CPortalProductoParametro } from '../models/B2CPortalProductoParametro.model';

@Injectable({ providedIn: 'root' })
export class RequestServices {
    private CONFIG: Configuration;
    private storageService: StorageService = new StorageService();
    private DEFAULT_URL:string = "";
    private S4_KEY: string;
    private HEADER_TENANT_INSTANCE:string = "X-Tenant-Instance";
    private HEADER_TENANT_INSTANCE_VALUE:string = "db-skynet";
    private HEADER_TENANT_DB = "X-Tenant-Db";
    private HEADER_TENANT_DB_VALUE = "quattro00084";

    constructor(private http: HttpClient) {
        this.CONFIG = new Configuration();
        this.S4_KEY = this.CONFIG.S4_KEY;
    }

    getRequest(requestGetConfig: RequestGetConfig): Observable<any> {              
        let parameters = "?d=" + this.storageService.getItem("d"); 
        
        parameters += ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');   
        let headers = (requestGetConfig.tkn)? this.getInjectionHeader("json",requestGetConfig.tkn): this.getInjectionHeader("json");
        return this.http.get<CopsisResponse>((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters, {headers});
    }
    
    getRequestPublic(requestGetConfig: RequestGetConfig): Observable<any> {
        let quattroB2C:QuattroB2C = new QuattroB2C();
       /* if(this.storageService.ifExist("quattroB2C")){
            quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
        }*/                
        let parameters = "?d=" + this.storageService.getItem("d") + '&s4_key=' + this.S4_KEY;
        parameters += ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : ''); 

        // let headers = new HttpHeaders()
        // .set("Content-Type", "application/json; charset=utf-8;")
        // .set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE)
        
        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters);
    }

    getRequestAutos(requestGetConfig: RequestGetConfig): Observable<any> {
        const quattroB2C: QuattroB2C = new QuattroB2C();
        let token = this.storageService.getItem("tkn");
        let parameters = "?auth=" + token + '&s4_key=' + this.S4_KEY;
        parameters += ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');

        /*let headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE)*/

        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters);
    }

    postRequest(requestPostConfig: RequestPostConfig): Observable<any> {
        // tslint:disable-next-line: max-line-length
        let quattroB2C:QuattroB2C = new QuattroB2C();
        if(this.storageService.ifExist("quattroB2C")){
            quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + 's4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        if (requestPostConfig.dataJSON instanceof Array) {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON[0].tkn = quattroB2C.tkn;
            }
            requestPostConfig.dataJSON[0].b = this.storageService.getItem("b");
        } else {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON.tkn = quattroB2C.tkn;
            }
            requestPostConfig.dataJSON.b = this.storageService.getItem("b");
        }

        const headers = new HttpHeaders();
        if (requestPostConfig.contentType) {   
            return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json;charset=utf-8;',
                    'Authorization': 'Bearer ' + this.storageService.getItem("tkn")
                })
            }).pipe(timeout(300000));
        }
        
        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8;')
        .set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE)
        .set(this.HEADER_TENANT_DB,this.HEADER_TENANT_DB_VALUE);

        return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), { headers }).pipe(timeout(300000));
    }

    postRequestAuth(requestPostConfig: RequestPostConfig): Observable<CopsisResponse> {     
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName;         
        let headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set("Authorization", "Basic UFJVREVOVElBTF9CMkM6a2JVY3V4bzExSkF6bW92dTFKR0ppQT09")
        return this.http.post<CopsisResponse>(url, JSON.stringify(requestPostConfig.dataJSON), { headers }).pipe(timeout(300000));
    }

    postRequestCopsisAPI(requestPostConfig: RequestPostConfig): Observable<CopsisResponse> {     
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName;         
        let headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set("x-api-key", "000000037-nkWuxai4igw_l9OBonHmvCCg4PY3GitCSy6eBEj_rSa8Z5j973aYG-7xJzwi0vUxI-W3xYPsAWuOONzwWf3eexFiKret3JrA1xI4i1Ia_-LR-AUu-bMu-ynJkO90AFGW-KAWMbYASTOlW5WwYI83cQ==")
        .set("Authorization", "Bearer " + this.storageService.getItem("tkn"))
        return this.http.post<CopsisResponse>(url, JSON.stringify(requestPostConfig.dataJSON), { headers }).pipe(timeout(300000));
    }


    putRequest(requestPostConfig: RequestPostConfig): Observable<CopsisResponse> {
        let quattroB2C:QuattroB2C = new QuattroB2C();
        if(this.storageService.ifExist("quattroB2C")){
            quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
        }
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName;            
        if (requestPostConfig.dataJSON instanceof Array) {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON[0].tkn = quattroB2C.tkn;
            }
        } else {
            requestPostConfig.dataJSON.d =  this.storageService.getItem("d");
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON.tkn = quattroB2C.tkn;
            }
        }
        let headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set("Authorization", "Bearer " + this.storageService.getItem("tkn"))
        .set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE)
        .set(this.HEADER_TENANT_DB,this.HEADER_TENANT_DB_VALUE);
        return this.http.put<CopsisResponse>(url, requestPostConfig.dataJSON, { headers }).pipe(timeout(300000));
    }
    postRequestLoginAES(requestPostConfig: RequestPostConfig): Observable<any> {              
        // tslint:disable-next-line: max-line-length
        let quattroB2C:QuattroB2C = new QuattroB2C();
        if(this.storageService.ifExist("quattroB2C")){
            quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + 's4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        if (requestPostConfig.dataJSON instanceof Array) {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON[0].tkn = quattroB2C.tkn;
            }
        } else {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON.tkn = quattroB2C.tkn;
            }
        }

        let headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set("Authorization", "Bearer " + this.storageService.getItem("f-tkn"))
        .set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE)
        .set(this.HEADER_TENANT_DB,this.HEADER_TENANT_DB_VALUE);

        return this.http.post(url, requestPostConfig.dataJSON, { headers }).pipe(timeout(300000));
    }

    postRequestAES(requestPostConfig: RequestPostConfig): Observable<any> {
        // tslint:disable-next-line: max-line-length
        let quattroB2C:QuattroB2C = new QuattroB2C();
        if(this.storageService.ifExist("quattroB2C")){
            quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName;// + '?' + 's4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        
        if (requestPostConfig.dataJSON instanceof Array) {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON[0].tkn = quattroB2C.tkn;
            }
        } else {
            requestPostConfig.dataJSON.d = requestPostConfig.letraD ? requestPostConfig.letraD : this.storageService.getItem("d");
            requestPostConfig.dataJSON.p =  this.storageService.getItem("p");
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON.tkn = quattroB2C.tkn;
            }
        }

        let headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set("Authorization", "Bearer " + (this.storageService.getItem("tkn") ? this.storageService.getItem("tkn") : requestPostConfig.tkn))
        .set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE)
        .set(this.HEADER_TENANT_DB,this.HEADER_TENANT_DB_VALUE)
        .set('X-API-KEY', this.storageService.getItem("api-key") ?? '');

        //headers.append('Content-Type', 'application/json; charset=utf-8;');
        //headers.append('Authorization', 'Bearer ' + this.storageService.getItem("tkn"));

        return this.http.post(url, requestPostConfig.dataJSON, { headers }).pipe(timeout(300000));
    }

    getRequestAES(requestGetConfig: RequestGetConfig): Observable<any> {
        let quattroB2C: QuattroB2C = new QuattroB2C();
        if(this.storageService.ifExist("quattroB2C")){
            quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
        }
        const url = (requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName;// + '?' + 's4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        let token = this.storageService.getItem("tkn");
        let parameters = "?auth=" + token + '&s4_key=' + this.S4_KEY;
        parameters += ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');

        /*let headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE)*/

        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters);
    }

    postRequestAsync(requestPostConfig: RequestPostConfig) {        
        let quattroB2C: QuattroB2C = new QuattroB2C();
        if(this.storageService.ifExist("quattroB2C")){
            quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
        }
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + 's4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        if (requestPostConfig.dataJSON instanceof Array) {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON[0].tkn = quattroB2C.tkn;
            }
            requestPostConfig.dataJSON[0].b = this.storageService.getItem("b");
        } else {
            if (quattroB2C?.tkn) {
                requestPostConfig.dataJSON.tkn = quattroB2C.tkn;
            }
            requestPostConfig.dataJSON.b = this.storageService.getItem("b");
        }

        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8;');
        this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), { headers: headers }).pipe(timeout(300000)).toPromise();
    }

    private transformParams(params: any): string {
        let paramString = '';

        if (Array.isArray(params)) {
            for (let param of params) {
                paramString += this.readJSONObject(param);
            }
        } else if (params !== undefined && typeof params === 'object') {
            paramString = this.readJSONObject(params);
        } 
        return paramString;
    }

    private readJSONObject(obj: any): string {
        // tslint:disable-next-line: variable-name
        const _keys = Object.keys(obj);
        let data: string = '';
        for (let _key of _keys) {
            data += '&' + _key + '=' + obj[_key];
        }

        return data;
    }
    private getInjectionHeader(method:string, tkn?:string, apiKey?:string):HttpHeaders {
        try {
            let token = this.storageService.getItem("tkn");
            let headers = new HttpHeaders()
            let methodName = "";
            switch(method.toLowerCase()) {
                case "json":
                    methodName = "application/json; charset=utf-8;";
                    break;
                case "x-www-form-urlencoded":
                    methodName = "application/x-www-form-urlencoded; charset=utf-8;";
                    break;
                case "form-data":
                    methodName = "multipart/form-data";
                break;
            }
            if(methodName !== '') {
                headers = headers.set("Content-Type", methodName);
            }
            switch (window.location.hostname) {
                case 'localhost':
                    headers = headers.set(this.HEADER_TENANT_INSTANCE,this.HEADER_TENANT_INSTANCE_VALUE);
                    headers = headers.set(this.HEADER_TENANT_DB,this.HEADER_TENANT_DB_VALUE);
                    if(tkn && tkn != ""){
                        headers = headers.set("Authorization", "Bearer " + tkn);   
                    } else {
                        headers = headers.set("Authorization", "Bearer " + token);   
                    }
                break;
                default:         
                    if(tkn && tkn != ""){
                        headers = headers.set("Authorization", "Bearer " + tkn);       
                    } else {
                        headers = headers.set("Authorization", "Bearer " + token);       
                    }
                break;
            }

            if (this.storageService.ifExist("api-key"))
                headers = headers.set('X-API-KEY', this.storageService.getItem("api-key"));

            return headers;   
        } catch (error) {
            console.error(error);
            throw new Error(`Error getInjectionHeader : ${error}`);
        }
    }

    async getParameter(portalProductoIdEnc: string, parametroID: string): Promise<B2CPortalProductoParametro[]> {
        const res = await this.getRequestAES({ projectName: new Configuration().API_B2C, apiName: 'b2c/publics/producto-parametro', params: [{ portalProductoIdEnc, parametroID }]}).toPromise();
        if (res.ok) {
            return res.result;
        }
        return [];
    }
}

export class RequestGetConfig {
    /**URL del proyecto API */
    projectName?: string | null;
    /**Endpoint */
    apiName: string = "";
    /**parametros para el api en formato JSON */
    params?: any;
    tkn?:any;
}

export class RequestPostConfig {
    /**URL del proyecto API */
    projectName?: string | null;
    /**Endpoint */
    apiName: string = "";
    /**parametros para el api en formato JSON */
    dataJSON?: any;    
    params?: any;
    formData?: FormData;
    contentType?: string;
    tkn?: string;
    letraD?: string;
}


